import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import moment from "moment";
import Icon from "module-common/Icon";
import Avatar from "module-common/Avatar";
import LabelList from "module-common/label-list/LabelList";

export default class Row extends Component {
  
  render() {
    const {
      id,
      index,
      firstName,
      lastName,
      email,
    } = this.props;

    return (
      <Wrapper>
        <Index>{index}.</Index>
        <Name>
            {firstName}
        </Name>
        <Name>
            {lastName}
        </Name>
        <Contact>{email}</Contact>
        <Label></Label>
        <Index>
          <Icon name="x-button-gray" />
        </Index>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex: none;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  align-items: center;
  padding: 10px;
  &:hover {
    background: #ececec;
    font-weight: 600;
    cursor: pointer;
  }
`;

const Index = styled.div`
  margin-left: 10px;
  flex: 1;
`;

const Name = styled.div`
  flex: 4;
  text-align: left;
`;

const StyledAvatar = styled(Avatar)`
  margin-right: 10px;
`;

const Contact = styled.div`
  flex: 3;
  text-align: left;
`;

const IconSocial = styled(Icon)`
  flex: 2;
`;

const Label = styled.div`
  flex: 4;
  margin-right: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-email-campaign/audience/member/Row.js